import i18n from '@/locales/i18n';

const constant = {
  service_type: {
    DEVICE_4G: 1,
    IN_STORE_WEB: 2,
    FILE_LINK: 3,
  },
  import_type: {
    SERVICE_POINT: 1,
    STORE: 2,
  },
  service_type_options: [
    {
      value: 1,
      text: i18n.t('store.checkbox.device_4g'),
    },
    {
      value: 2,
      text: i18n.t('store.checkbox.in_store_web'),
    },
    {
      value: 3,
      text: i18n.t('store.checkbox.file_link'),
    },
  ],
  status_options: [
    {
      value: 1,
      text: i18n.t('store.options.active'),
    },
    {
      value: 0,
      text: i18n.t('store.options.inactive'),
    },
  ],
  status: {
    ACTIVE: 1,
    INACTIVE: 0,
  },
};

export default constant;
